import { inject } from '@angular/core'
import { CanActivateFn, Router } from '@angular/router'
import { Store } from '@ngrx/store'
import { getClient } from '../state/client/client.selectors'
import { map, take } from 'rxjs'

export const CelebrationsGuard: CanActivateFn = () => {
	const store = inject(Store)
	const router = inject(Router)

	return store.select(getClient).pipe(
		take(1),
		map(client => {
			const isLoggedIn = !!client
			const hasVoucher = !!client?.voucher

			if (!isLoggedIn || !hasVoucher) {
				router.navigate(['/'])
				return false
			}

			return true
		})
	)
}
